import { cva } from 'class-variance-authority';
import {} from 'react';
export const spinnerStyles = cva(['block', 'text-ai-primary'], {
    variants: {
        size: {
            xxs: ['w-5', 'h-5'],
            xs: ['w-6', 'h-6'],
            s: ['w-8', 'w-8'],
            1: ['w-4', 'h-4'],
            2: ['w-[14px]', 'h-[14px]'],
            3: ['w-5', 'h-5'],
            4: ['w-[18px]', 'h-[18px]'],
            5: ['w-7', 'h-7'],
            10: ['w-[154px]', 'h-[154px]', 'p-2', 'overflow-visible'],
        },
    },
    defaultVariants: {
        size: 's',
    },
});
